import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

interface StyleProps {
  variant?: 'default' | 'secondary';
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
      borderRadius: 8,
      height: 8,
      padding: 4,
      backgroundColor: ({ variant }: StyleProps) =>
        variant === 'secondary' ? theme.color.greys[0] : theme.color.greys[10],
  },
  bar: {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      height: 8,
      backgroundColor: theme.color.violets[100],
      top: 0,
      left: 0,
      zIndex: 1
  },
  label: {
    marginBottom: 4,
  },
  helperText: {
    marginTop: 4,
  },
}), { name: 'LinearProgressBar', index: StylesIndexInjections.UI_MOLECULES });

